import AlertBox from '../../../../components/AlertBox';
import r from '../../../../services/Replacement';

interface Props {
    onDismiss: () => void;
}

export default function CalendarSettingsAlert({ onDismiss }: Props) {
    return (
        <AlertBox
            colour="BLUE"
            title={`Create ${r('meeting.name.short.plural.low')} automatically from your company calendar!`}
            compact={false}
            onDismiss={onDismiss}
        >
            Calendar events can now be detected and synced to Small Improvements. To manage which calendar events
            you&apos;d like to sync, please click &quot;Calendar Settings&quot; above.
        </AlertBox>
    );
}
